import {SHAPE_PART_ID} from "../constants";

export const SHAPE_PART_IDS_HIDDEN_IN_REGULAR_MODE = [
  SHAPE_PART_ID.seamPiece,
  SHAPE_PART_ID.slabPlaceHolder
]
